import React, { useEffect, useState } from "react";
import styled from "styled-components";
import ServicePopUp from "./ServicePopUp";
import { happyClients, legalServices, shortTerm } from "../const";
import { useNavigate } from "react-router-dom";

function MySection({ video }) {
  const navigate = useNavigate();
  useEffect(() => {
    const fonts = [
      "https://fonts.googleapis.com/css2?family=Poppins:wght@400;700&display=swap",
      "https://fonts.googleapis.com/css2?family=Belanosima&display=swap",
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.7.2/css/all.min.css",
    ];
    fonts.forEach((href) => {
      const link = document.createElement("link");
      link.href = href;
      link.rel = "stylesheet";
      document.head.appendChild(link);
    });
  }, []);

  return (
    <SectionWrapper>
      <TopHeading>
        <h1> WHY EMBARK PROPERTIES ? </h1>
        <p>
          Embark Properties harnesses deep Dubai market insight and a powerful
          network to secure top opportunities. We deliver bespoke
          strategies—backed by data-driven pricing and transparent
          communication—to streamline every transaction. Trust us to champion
          your investment with integrity and exceptional results.
        </p>
      </TopHeading>
      <BottomContent>
        <LeftBox>
          <BoxRow>
            <SmallBox style={{cursor:"pointer"}} onClick={() => navigate('/mortgage')}>
              <i class="fa-solid fa-hand-holding-dollar"></i>
              <h2> Mortgage </h2>
            </SmallBox>
            <ServicePopUp title={"Short Term Rental"} icon={"fa-solid fa-house-user"} desc={shortTerm}/>
            {/* <SmallBox
              onClick={() => setShowPopup(true)}
              style={{ cursor: "pointer" }}
            >
              <i className="fa-solid fa-house-user"> </i>{" "}
              <h2> Short Term Rental </h2>
            </SmallBox> */}
          </BoxRow>
          <BoxRow>
            <ServicePopUp title={"Legal Support"} icon={"fas fa-balance-scale"} desc={legalServices}/>
            {/* <SmallBox
              onClick={() => setShowPopup(true)}
              style={{ cursor: "pointer" }}
            >
              <i class="fas fa-balance-scale"></i>
              <h2> Legal Support </h2>
            </SmallBox>

             */}
             <ServicePopUp title={"10K + Happy Clients & Countings"} icon={"fas fa-users"} desc={happyClients}/>
          </BoxRow>
        </LeftBox>
        <RightBox>
          <StyledVideo
            src={video}
            controls
            autoPlay
            muted
            loop
            title="EMBARK Properties Video"
          />
        </RightBox>
      </BottomContent>
      
    </SectionWrapper>
  );
}

export default MySection;

// ------------------ STYLED COMPONENTS ------------------

const SectionWrapper = styled.div`
  background: #000;
  padding: 40px 20px;
  font-family: "Poppins", sans-serif;
`;

const TopHeading = styled.div`
  text-align: center;
  max-width: 1000px;
  margin: 0 auto;

  h1 {
    font-family: "Paris Avenue";
    font-size: 24px;
    margin-bottom: 10px;
    color: #fff;
    margin-top: 0px;

    @media (min-width: 768px) {
      font-size: 2.5rem;
    }

    @media (min-width: 1200px) {
      font-size: 3rem;
    }
  }

  p {
    font-size: 0.8rem;
    color: #fff;

    @media (min-width: 768px) {
      font-size: 1.05rem;
    }

    @media (min-width: 1200px) {
      font-size: 1.1rem;
    }
  }
`;

const BottomContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 40px;

  @media (min-width: 992px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    padding-left: 4%;
    padding-right: 4%;
  }
`;

const LeftBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const RightBox = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    margin-top: 20px;
  }
`;

const BoxRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
`;

const SmallBox = styled.div`
  background-color: #000;
  flex: 1 1 140px;
  max-width: auto;
  height: auto;
  padding: 5%;
  text-align: center;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s, background-color 0.3s;
  border: 1px solid #a78c4c;

  &:hover {
    transform: translateY(-5px);
    background-color: rgb(167, 140, 76);

    i {
      color: #fff;
    }

    h2 {
      color: #fff;
    }
  }

  i {
    font-size: 2.5rem;
    color: rgb(167, 140, 76);
    margin-bottom: 10px;
    transition: color 0.3s;
  }

  img {
    width: 50px;
  }

  h2 {
    font-size: 22px;
    margin: 10px 0 5px;
    color: rgb(167, 140, 76);
    margin-top: 20px;
    transition: color 0.3s;

    @media (max-width: 768px) {
      font-size: 18px;
    }
  }

  p {
    font-size: 15px;
    margin: 0;
    color: #555;
  }
`;

const StyledVideo = styled.video`
  width: 100%;
  height: auto;
  object-fit: cover;

  @media (max-width: 768px) {
    max-height: 250px;
  }
`;
